import styled from 'styled-components';
import {Device} from '../../services/constants';

export const CardContainer = styled.div`
    width: calc(100% - 80px);
    max-width: 284px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
    align-items: center;
    margin: 64px 16px 0 16px;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0 6px 16px 3px rgba(0, 0, 0, 0.15);
    background-color: var(--neutral-0);
    z-index: 3;
    transition: 0.2s;

    @media ${Device.mobile} {
        margin: 128px 16px 0 16px;
    }
`;
export const Heading = styled.p`
    text-align: center;
    font-weight: bold;
`;
export const Message = styled.p`
    text-align: center;
`;
export const Button = styled.button`
    width: 100%;
    height: 48px;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    margin-top: auto;
    border: none;
    border-radius: 8px;
    color: var(--text-0);
    background-color: var(--primary-500);
    line-height: 1.25;
    transition: 0.2s;
    &:hover {
        cursor: pointer;
        background-color: var(--neutral-800);
    }
    &:active {
        background-color: var(--neutral-500);
    }
`;
export const Image = styled.i`
    width: 64px;
    height: 64px;
    font-size: 64px;
    background: linear-gradient(to right, #ffd43a, #f87328);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
`;
